import KeyboardShortcutsModal from './keyboard_shortcuts'

export default KeyboardShortcutsModal
